import { render, staticRenderFns } from "./goodsItem.vue?vue&type=template&id=add78fba&scoped=true"
import script from "./goodsItem.vue?vue&type=script&lang=js"
export * from "./goodsItem.vue?vue&type=script&lang=js"
import style0 from "./goodsItem.vue?vue&type=style&index=0&id=add78fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add78fba",
  null
  
)

export default component.exports